import { Map, List, fromJS } from "immutable";
import { createAction, handleActions } from "redux-actions";
import { pender } from "redux-pender";
import axios from "axios";
import { apiUrl, execUrl } from "libs/commonVar";

import * as admLib from "libs/adminLib";
import * as configLib from "libs/configLib";
import * as admData from "libs/normalizer";

// action types
const INITIAL_STORE = "admin/INITIAL_STORE";
const TOGGLE_MENU = "admin/TOGGLE_MENU";
const GET_SYSCONF_BASIC = "admin/GET_SYSCONF_BASIC";
const GET_SYSCONF_SMTP = "admin/GET_SYSCONF_SMTP";
const GET_SYSCONF_SYNC = "admin/GET_SYSCONF_SYNC";

const UPDATE_SYSCONF = "admin/UPDATE_SYSCONF";
const GHECK_SYSSMTP = "admin/GHECK_SYSSMTP";
const SYSCONF_INITIAL_BASIC = "admin/SYSCONF_INITIAL_BASIC";
const SYSCONF_INITIAL_SMTP = "admin/SYSCONF_INITIAL_SMTP";

const POST_SYSCONF_SYNC = "admin/POST_SYSCONF_SYNC";
const POST_SYSCONF_SYNC_TEST = "admin/POST_SYSCONF_SYNC_TEST";

// action creator
export const initialStore = createAction(INITIAL_STORE);
export const toggleMenuVisible = createAction(TOGGLE_MENU);
export const getSystemConfigBasic = createAction(
  GET_SYSCONF_BASIC,
  admLib.getSystemConfigBasic
);
export const getSystemConfigSmtp = createAction(
  GET_SYSCONF_SMTP,
  admLib.getSystemConfigSmtp
);
export const getSystemConfigSync = createAction(
  GET_SYSCONF_SYNC,
  admLib.getSystemConfigSync
);
export const updateSystemConfig = createAction(
  UPDATE_SYSCONF,
  admLib.updateSystemConfig
);
export const checkSmtp = createAction(GHECK_SYSSMTP, configLib.checkSmtp);
export const SystemConfigInitBasic = createAction(
  SYSCONF_INITIAL_BASIC,
  admLib.SystemConfigInitBasic
);
export const SystemConfigInitSmtp = createAction(
  SYSCONF_INITIAL_SMTP,
  admLib.SystemConfigInitSmtp
);

export const postSync = createAction(POST_SYSCONF_SYNC, admLib.postSync);

export const postSyncTest = createAction(
  POST_SYSCONF_SYNC_TEST,
  admLib.postSyncTest
);

// initial state
const initialState = fromJS({
  menuOpen: true,
  configBasic: {},
  configSmtp: {},
  configSync: {},
});

// reducer
export default handleActions(
  {
    [INITIAL_STORE]: (state, action) => {
      return initialState;
    },
    [TOGGLE_MENU]: (state, action) => {
      return state.set("menuOpen", !state.get("menuOpen"));
    },
    ...pender({
      type: GET_SYSCONF_BASIC,
      onSuccess: (state, action) => {
        if (!!action.payload) {
          const { list } = action.payload.data;

          return state.set(
            "configBasic",
            fromJS(admData.systemConfigData(list))
          );
        } else {
          return state;
        }
      },
      onFailure: (state, action) => {
        console.log("GET_SYSCONF_BASIC 실패");

        // 401 등 실패에 대한 적절한 처리 필요함
        return state; //state.set('configBasic', initialState.get('configBasic'));
      },
    }),
    ...pender({
      type: GET_SYSCONF_SMTP,
      onSuccess: (state, action) => {
        if (!!action.payload) {
          const { list } = action.payload.data;

          return state.set(
            "configSmtp",
            fromJS(admData.systemConfigData(list))
          );
        } else {
          return state;
        }
      },
      onFailure: (state, action) => {
        console.log("GET_SYSCONF_SMTP 실패");

        // 401 등 실패에 대한 적절한 처리 필요함
        return state; //state.set('configSmtp', initialState.get('configSmtp'));
      },
    }),
    ...pender({
      type: GET_SYSCONF_SYNC,
      onSuccess: (state, action) => {
        if (!!action.payload) {
          const { list } = action.payload.data;

          return state.set(
            "configSync",
            fromJS(admData.systemConfigData(list))
          );
        } else {
          return state;
        }
      },
      onFailure: (state, action) => {
        console.log("GET_SYSCONF_SYNC 실패");

        // 401 등 실패에 대한 적절한 처리 필요함
        return state; //state.set('configSmtp', initialState.get('configSmtp'));
      },
    }),

    ...pender({
      type: UPDATE_SYSCONF,
      onSuccess: (state, action) => {
        if (!!action.payload) {
          const { list } = action.payload.data;
          const { category, parameter, value } = list[0];

          const configCategory =
            category === "basic"
              ? "configBasic"
              : category === "smtp"
              ? "configSmtp"
              : "configSync";

          return state.setIn(
            [configCategory, "parameter", parameter, "beforeValue"],
            value
          );
        } else {
          return state;
        }
      },
      onFailure: (state, action) => {
        console.log("UPDATE_SYSCONF 실패");

        // 401 등 실패에 대한 적절한 처리 필요함
        return state;
      },
    }),
    ...pender({
      type: GHECK_SYSSMTP,
      onSuccess: (state, action) => {
        if (!!action.payload) {
          const { list } = action.payload.data;

          return state.setIn(
            ["configSmtp", "parameter", "mailSmtpTested"],
            fromJS(list)
          );
        } else {
          return state;
        }
      },
      onFailure: (state, action) => {
        console.log("GHECK_SYSSMTP 실패");

        return state;
      },
    }),
    ...pender({
      type: SYSCONF_INITIAL_BASIC,
      onSuccess: (state, action) => {
        return initialState;
      },
      onFailure: (state, action) => {
        return state;
      },
    }),
    ...pender({
      type: SYSCONF_INITIAL_SMTP,
      onSuccess: (state, action) => {
        return initialState;
      },
      onFailure: (state, action) => {
        return state;
      },
    }),
    ...pender({
      type: POST_SYSCONF_SYNC,
      onSuccess: (state, action) => {
        return state;
      },
      onFailure: (state, action) => {
        console.log("POST_SYSCONF_SYNC 실패");

        return state;
      },
    }),
    ...pender({
      type: POST_SYSCONF_SYNC_TEST,
      onSuccess: (state, action) => {
        return state;
      },
      onFailure: (state, action) => {
        console.log("POST_SYSCONF_SYNC_TEST 실패");

        return state;
      },
    }),
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/script/modules/admin.js